import { fetchData } from './api';
import { handleError } from '../context/errors/errorUtils';

export const fetchPathSteps = async ({ userId, levelGroup }) => {
  try {
    return await fetchData('/api/path/steps', 'POST', { userId, levelGroup });
  } catch (error) {
    handleError({
      code: 'PATH_STEPS_FETCH_ERROR',
      error,
      context: { module: 'fetchPathSteps', userId, levelGroup },
      showToUser: false
    });
    throw error;
  }
};

export const fetchPathLearnInit = async ({ userId, stepId }) => {
  try {
    return await fetchData('/api/path/learn/init', 'POST', { userId, stepId });
  } catch (error) {
    handleError({
      code: 'PATH_LEARN_INIT_ERROR',
      error,
      context: { module: 'fetchPathLearnInit', userId, stepId },
      showToUser: true
    });
    throw error;
  }
};

export const markPathLearned = async ({ userId, stepId, wordId }) => {
  try {
    return await fetchData('/api/path/learn/mark', 'POST', { userId, stepId, wordId });
  } catch (error) {
    handleError({
      code: 'PATH_LEARN_MARK_ERROR',
      error,
      context: { module: 'markPathLearned', userId, stepId, wordId },
      showToUser: false
    });
    throw error;
  }
};

export const reportPathHintsShown = async ({ userId, wordId, hintIds }) => {
  try {
    return await fetchData('/api/path/learn/hints/shown', 'POST', { userId, wordId, hintIds });
  } catch (error) {
    handleError({
      code: 'PATH_HINTS_SHOWN_ERROR',
      error,
      context: { module: 'reportPathHintsShown', userId, wordId, hintIds },
      showToUser: false
    });
    throw error;
  }
};

export const fetchPathPracticeInit = async ({ userId, stepId, chunkIds, totalItems }) => {
  try {
    return await fetchData('/api/path/practice/init', 'POST', { userId, stepId, chunkIds, totalItems });
  } catch (error) {
    handleError({
      code: 'PATH_PRACTICE_INIT_ERROR',
      error,
      context: { module: 'fetchPathPracticeInit', userId, stepId, chunkIds, totalItems },
      showToUser: true
    });
    throw error;
  }
};

export const updatePathPracticeProgress = async ({ userId, stepId, delta = 1 }) => {
  try {
    return await fetchData('/api/path/practice/progress', 'POST', { userId, stepId, delta });
  } catch (error) {
    handleError({
      code: 'PATH_PRACTICE_PROGRESS_ERROR',
      error,
      context: { module: 'updatePathPracticeProgress', userId, stepId, delta },
      showToUser: false
    });
    throw error;
  }
};
